module.exports = __webpack_public_path__ + "img/login-dark.5b4e7348.svg";